/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { useReactTable, flexRender, getCoreRowModel } from "@tanstack/react-table";
import {
  cellCss,
  getRowContentCss,
  getRowCss,
  tableWrapperCss,
} from "tables/common/TableBordered/index.css";
import TABLE_ROLES from "helpers/table/roles";
import useTableState from "hooks/useTableState";
import HeaderGroups from "tables/common/TableBordered/HeaderGroups";
import COLUMNS from "./columns";

export default function InsightsTable({
  step,
  perPage,
  data,
  isFetching,
  isLoading,
  tableId,
  allTags,
}) {
  const tableState = useTableState({
    length: perPage || 10,
    columns: COLUMNS,
    data,
    isLoading,
  });

  const { getHeaderGroups, getRowModel, getCenterTotalSize } = useReactTable({
    data: tableState.data,
    columns: tableState.columns,
    getCoreRowModel: getCoreRowModel(),
    meta: {
      step,
      allTags,
    },
  });

  const isDataUpdating = !isLoading && isFetching;

  return (
    <div id={tableId} css={tableWrapperCss}>
      <div role={TABLE_ROLES.table} style={{ width: getCenterTotalSize() }}>
        <HeaderGroups getHeaderGroups={getHeaderGroups} />

        <div role={TABLE_ROLES.rowGroup}>
          {getRowModel().rows.map((row) => (
            <div
              key={row.id}
              role={TABLE_ROLES.row}
              css={getRowCss({ borderBottom: true })}
              className="flex-column"
            >
              <div css={getRowContentCss({ isDataUpdating })} className="flex">
                {row.getVisibleCells().map(({ id, column, getContext }) => {
                  const { cell } = column.columnDef;

                  return (
                    <div
                      key={id}
                      role={TABLE_ROLES.cell}
                      css={cellCss}
                      className="main-text sibling"
                      style={{ width: column.getSize() }}
                    >
                      {flexRender(cell, getContext())}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

InsightsTable.propTypes = {
  step: PropTypes.string,
  perPage: PropTypes.number,
  tableId: PropTypes.string,
  isFetching: PropTypes.bool,
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  allTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
};
